import React, { FunctionComponent, useEffect, useState } from 'react';
import Header from 'ui/atoms/header';
import Input from 'ui/atoms/input';
import Section from 'ui/atoms/section';
import Translate from 'ui/atoms/translate';
import { VoucherFields } from 'apps/issuer/pages/vouchers/create-voucher';

interface VoucherUsesTotalProps {
  Form: any;
  values: VoucherFields;
  numberOfUsesTotalAmount: number | undefined;
  onChangeUsesTotal: (noOfUses: string, amount: number) => void;
}

export enum VoucherUsesTotalEnum {
  UNLIMITED = 'unlimited',
  LIMITED_TO = 'limitedTo',
}

const VoucherUsesTotal: FunctionComponent<VoucherUsesTotalProps> = ({
  Form,
  values,
  numberOfUsesTotalAmount,
  onChangeUsesTotal,
}) => {
  const [amount, setAmount] = useState(numberOfUsesTotalAmount || 1);

  useEffect(() => {
    onChangeUsesTotal(values.numberOfUsesTotal, amount);
  }, [values.numberOfUsesTotal, amount]);

  return (
    <Section>
      <Form.Group name="numberOfUsesTotal" required={true}>
        <Header spacing="medium">
          <Translate name="createVoucherForm.numberOfUsesTotal.label" />
        </Header>
        <Section spacing="small">
          <Form.GroupToggle>
            {Object.values(VoucherUsesTotalEnum).map((option) => (
              <Form.Radio value={option} key={option}>
                <Translate name={`createVoucherForm.${option}`} />
              </Form.Radio>
            ))}
          </Form.GroupToggle>
        </Section>
        <Input
          type="number"
          min={1}
          label={<Translate name={'createVoucherForm.amount'} />}
          disabled={values.numberOfUsesTotal === VoucherUsesTotalEnum.UNLIMITED}
          onChange={(e: any) => setAmount(e.target.value)}
          value={values.numberOfUsesTotal === VoucherUsesTotalEnum.UNLIMITED ? '' : amount.toString()}
        />
        <small>
          <Translate name={'createVoucherForm.numberOfUsesTotal.info'} />
        </small>
      </Form.Group>
    </Section>
  );
};

export default VoucherUsesTotal;
